module.exports = __webpack_public_path__ + "static/media/hyundai-provider.c82cb8a6.svg";